export const clubCheck = (input) => input.toLowerCase().trim().split(" ")[0];

export const hasDifferentStrings = (arr) =>
  !arr.every((s) => clubCheck(s) === clubCheck(arr[0]));

export const hasDifferentClubs = (arr) => {
  const midIron = ["5i", "6i", "7i"];
  const allSame = arr.every((s) => clubCheck(s) === clubCheck(arr[0]));
  const allMidIron = arr.every((s) => midIron.includes(clubCheck(s)));
  return !(allSame || allMidIron);
};

export const hasNotAnalyzed = (arr) => !arr.every(Boolean);

export const createVerificationState = (
  credits,
  verificationUsers,
  verificationClubs,
  verificationAnalysed,
  verificationCameraAngles
) => {
  // default
  let next = { errorType: "", errorValues: null, isError: false };

  if (credits <= 0) {
    next = { errorType: "missingCredits", errorValues: null, isError: true };
  } else if (hasDifferentStrings(verificationUsers)) {
    next = {
      errorType: "mixedUsers",
      errorValues: Array.from(new Set(verificationUsers)).join(", "),
      isError: true,
    };
  } else if (hasDifferentClubs(verificationClubs)) {
    next = {
      errorType: "mixedClubs",
      errorValues: Array.from(new Set(verificationClubs)).join(", "),
      isError: true,
    };
  } else if (hasNotAnalyzed(verificationAnalysed)) {
    next = { errorType: "hasNotAnalyzed", errorValues: [], isError: true };
  } else if (
    verificationCameraAngles.map((x) => x.toUpperCase()).includes("DTL")
  ) {
    next = {
      errorType: "mixedCameraAngles",
      errorValues: "Down The Line videos are unsupported",
      isError: true,
    };
  }

  return next;
};
